import { createContext, useContext, Context, PropsWithChildren, useMemo } from 'react'

import Router from './router'

const RouterContext = createContext<Router | undefined>(undefined)

interface Props {}

export const useRouter = (): Router => {
  return useContext(RouterContext as Context<Router>)
}

const RouterProvider = (props: PropsWithChildren<Props>) => {
  const { children } = props
  const router = useMemo(() => new Router(), [])
  return <RouterContext.Provider value={router}>{children}</RouterContext.Provider>
}

export default RouterProvider
